import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=338d321a&scoped=true&class=content-notfound&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=338d321a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338d321a",
  null
  
)

export default component.exports